<template>
    <div>
        <b-modal id="payment-method-search" size="xl" content-class="shadow" :hide-footer="true" :title="$t('payment_method.header')" body-class='p-0' @show="fetchPaymentMethods" centered>
            <div class="row py-4 px-3 align-items-stretch bg-light border border-bottom mx-0">
                <div class="col-12 col-lg-5 mb-3 mb-lg-0">
                    <div class="input-group">
                        <input type="text" class="form-control" :placeholder="$t('payment_method_search.form.filter_by_name_placeholder')" v-model="searchString" v-on:keyup="searchMethods">
                        <div class="input-group-append">
                            <span class="input-group-text" id="search-addon"><i class="fal fa-search text-primary"></i></span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-5 mb-3 mb-lg-0">
                    <v-select
                        v-on:input="fetchPaymentMethods"
                        :placeholder="$t('payment_method_search.form.filter_by_country_placeholder')"
                        id='search-country'
                        class="form-control"
                        :options="countries"
                        v-model="searchCountry"
                        aria-describedby="country-addon"
                        :reduce="country => country.code"
                        label="name"
                        autocomplete="none"></v-select>
                </div>
                <div class="col-12 col-lg-2">
                    <button class="btn btn-outline-primary btn-block btn-sm h-100" style="letter-spacing:normal;" @click="showAllMethods" :disabled="!searching">Show All</button>
                </div>
            </div>
            <template v-if="!loading">
                <template v-if="paymentMethods.length > 0">
                    <div class="row px-4 pt-4" v-if="searching">
                        <div class="col-12">
                            <h5 class="mb-0">{{ $t("payment_method_search.search_results") }}</h5>
                        </div>
                    </div>
                    <div class="row px-4 pt-4" v-if="!searching">
                        <div class="col-12">
                            <h5 class="mb-0">{{ $t("payment_method_search.local_payment_methods") }}</h5>
                        </div>
                    </div>
                    <div class="row p-4 no-gutters justify-content-sm-center justify-content-lg-start" v-if="!searching">
                        <div class="col-4 col-md-auto mb-2 px-1" v-for="method in paymentMethods" :key="method.ident" v-if="(method.countries[0] === '*' || method.countries.includes(country))">
                            <img data-toggle="tooltip" data-placement="top" class="border border-2 rounded img-fluid payment-method-item" :src="method.image" :title="method.name" :alt="method.name" :data-method="method.ident" @click="selectMethod(method.ident)" />
                        </div>
                    </div>
                    <div class="row px-4 pt-0" v-if="!searching">
                        <div class="col-12">
                            <h5 class="mb-0">{{ $t("payment_method_search.other_payment_methods") }}</h5>
                        </div>
                    </div>
                    <div class="row p-4 no-gutters justify-content-sm-center justify-content-lg-start">
                        <div class="col-4 col-md-auto mb-2 px-1" v-for="method in paymentMethods" :key="method.ident"  v-if="searching || (method.countries[0] !== '*' && !method.countries.includes(country))">
                            <img data-toggle="tooltip" data-placement="top" class="border border-2 rounded img-fluid payment-method-item" :src="method.image" :title="method.name" :alt="method.name" :data-method="method.ident" @click="selectMethod(method.ident)" />
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="row px-4 py-4">
                        <div class="col-12">
                            <p class="mb-0">{{ $t("payment_method_search.no_results")}}</p>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="row px-4 py-4">
                    <div class="col-12">
                        <i class="fa fa-spin fa-spinner"></i>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { getData as getCountries } from "country-list";
    import { debounce } from "lodash";
    import { mapState } from "vuex";

    export default {
        name: "PaymentMethodSearch",
        data() {
            return {
                paymentMethods: [],
                countries: getCountries(),
                searchCountry : '',
                searchString : '',
                searching: false,
                loading: false
            }
        },
        computed: mapState({
            country: state => state.customer.country
        }),
        methods: {
            fetchPaymentMethods() {
                this.paymentMethods = [];
                this.loading = true;
                axios.get(tebex.application.basketApi + "/payment/method", { params: {
                    country: this.searchCountry ? this.searchCountry : '',
                    name: this.searchString ? this.searchString : ''
                }}).then(response => {
                    this.paymentMethods = response.data.data;
                }).finally(() => {
                    this.loading = false;
                    this.searching = (this.searchCountry !== "" || this.searchString !== "");
                });
            },
            searchMethods: debounce(function () {
                this.fetchPaymentMethods(this.searchCountry, this.searchString);
            }, 500),
            selectMethod(ident) {
                this.$store.dispatch('selectPaymentMethod', ident);
                this.$bvModal.hide('payment-method-search');
            },
            showAllMethods() {
                this.searchCountry = "";
                this.searchString = "";
                this.fetchPaymentMethods();
            }
        }
    }
</script>

<style scoped>

</style>
